'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'CONTÁCTANOS',
    link: '/contacte'
  }, {
    text: 'INGRESAR',
    link: ''
  }],
  loginLink: {
    text: 'INGRESAR',
    src: ''
  },
  siteLinks: [{
    title: {
      text: 'PRODUCTOS'
    },
    list: [{
      text: 'Audit Service',
      src: '/travel-expense-audit-service'
    }, {
      text: 'Budget',
      src: '/administracion-budget'
    }, {
      text: 'Expense',
      src: '/expense-management'
    }, {
      text: 'Intelligence',
      src: '/reportes-analisis-inteligentes'
    }, {
      text: 'Invoice',
      src: '/automatizacion-del-proceso-de-proveedores'
    }, {
      text: 'Request',
      src: '/expense-approval-system'
    }, {
      text: 'Risk Messaging',
      src: '/localizacion-alertas'
    }, {
      text: 'Service Administration',
      src: '/service-administration'
    }, {
      text: 'Travel',
      src: '/solicitud-de-viajes'
    }, {
      text: 'Travel & Expense',
      src: '/travel-expense'
    }, {
      text: 'User Support Desk',
      src: '/user-support-desk'
    }, {
      text: 'La Plataforma de SAP Concur',
      src: '/open-platform-apps'
    }, {
      text: 'Todos los Productos',
      src: '/all-products-page'
    }]
  }, {
    title: {
      text: 'SOLUCIONES'
    },
    list: [{
      text: 'Gestion Inteligente de Gastos',
      src: '/intelligent-spend-management'
    }, {
      text: 'Para Lideres Financieros',
      src: '/financial-manager-solutions'
    }, {
      text: 'Para Riesgo y Cumplimiento',
      src: '/risk-and-compliance'
    }, {
      text: 'Para Visibilidad y Cumplimiento',
      src: '/visibility-and-compliance'
    }, {
      text: 'Todas las Soluciones',
      src: '/solutions'
    }]
  }, {
    title: {
      text: 'NOSOTROS'
    },
    list: [{
      text: 'Acerca de Concur',
      src: '/why-concur'
    }, {
      text: 'Concur Platform',
      src: '/concur-integrated-ecosystem'
    }, {
      text: 'Ubicación de oficinas',
      src: '/contact/offices'
    }, {
      text: 'Contáctanos',
      src: '/contacte',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'RECURSOS'
    },
    list: [{
      text: 'Biblioteca de recursos',
      src: '/resource-center'
    }, {
      text: 'Movilidad',
      src: '/acceso-desde-dispotivo-movil'
    }, {
      text: 'Prensa',
      src: '/media-resources/press-releases'
    }, {
      text: 'Demo De Expense',
      src: '/self-guided-demo-expense-es-mx',
      classes: 'call-out'
    }, {
      text: 'Demo De Invoice',
      src: '/self-guided-demo-invoice-es-mx',
      classes: 'call-out'
    }]
  }],
  supportLinks: [{
    text: 'CONCUR BLOG',
    href: ''
  }, {
    text: 'CONTÁCTE',
    href: '/contacte'
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};